import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';

@Component({
  selector: 'app-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.css'],
})
export class EventDetailsComponent implements OnInit {
  private getApi = environment.url + environment.eventGet;
  /**
   * Constructs an instance of the EventDetailsComponent.
   * @param route - Service to access route parameters.
   * @param router - Service for navigating between routes.
   * @param location - Service to interact with the browser's URL.
   * @param makeapi - Service to make API calls.
   * @param getdata - Service to manage application state.
   */
  constructor(
    private route: ActivatedRoute, // Injects ActivatedRoute to access route parameters
    private router: Router, // Injects Router for navigation
    private location: Location, // Injects Location to interact with browser's URL
    private makeapi: ApiService, // Injects ApiService for API calls
    private getdata: ValueService // Injects ValueService for managing application state
  ) {}
  roleValue;
  /**
   * Initializes the component.
   * Sets visibility, retrieves role from session storage, and subscribes to query parameters.
   */
  ngOnInit(): void {
    // Set the visibility flag to true
    this.getdata.isVisibleSource.next(true);

    // Retrieve user role from session storage
    this.roleValue = sessionStorage.getItem('role');

    // Subscribe to route query parameters and fetch event details if _id is present
    this.route.queryParams
      .pipe(filter((params) => params._id))
      .subscribe((params) => {
        this.viewEvent(atob(params._id)); // Decode the _id and view event details
      });
  }
  eventView: any = [];
  /**
   * Fetches the event details from the API using the provided ID.
   * The data is stored in the component's `eventView` property.
   * @param id The ID of the event to fetch.
   */
  viewEvent(id: string): void {
    // Show the loading indicator while the data is being fetched
    this.getdata.amizhthLoader('show');
    // Make the API request to fetch the event details
    this.makeapi
      .method(this.getApi + 'id=' + id, '', 'getunauth')
      .subscribe((data) => {
        // Hide the loading indicator when the data is fetched successfully
        this.getdata.amizhthLoader('hide');
        // Store the event details in the component's `eventView` property
        this.eventView = data;
      });
  }
  /**
   * Navigate to the event page.
   *
   * This function navigates the user to the event page when called.
   */
  backBtn() {
    // Navigate to the event page
    this.router.navigateByUrl('/event');
  }
  /**
   * Navigate back to the previous page.
   *
   * This function uses the Location service to navigate back to the previous page.
   * It is called when the back button is clicked.
   */
  backBtn2(): void {
    // Navigate back to the previous page
    this.location.back();
  }
}
